export default {
    name: "SettingsUserManagementHeader",

    props: {
        users_count: {
            type: Number,
            default: 0
        },
        active_users_count: {
            type: Number,
            default: 0
        }
    },

    emits: ["open-add-user"],

    computed: {
        stats() {
            return [
                { label: "Total users", value: this.users_count, icon: "bi-people", tone: "bg-warning-subtle text-warning" },
                { label: "Active", value: this.active_users_count, icon: "bi-person-check", tone: "bg-success-subtle text-success" },
                { label: "Inactive", value: Math.max(this.users_count - this.active_users_count, 0), icon: "bi-person-slash", tone: "bg-secondary-subtle text-secondary" }
            ];
        }
    }
};
